import { LineIconType } from '../LineIconWidget.types';
import { HalfCurve, resizeHalfCurve } from './HalfCurve';
import { QuarterCurve, resizeQuarterCurve } from './QuarterCurve';

export const LINE_TYPE_MAP = {
  [LineIconType.HalfCurve]: HalfCurve,
  [LineIconType.QuarterCurve]: QuarterCurve,
};

export const LINE_RESIZE_MAP = {
  [LineIconType.HalfCurve]: resizeHalfCurve,
  [LineIconType.QuarterCurve]: resizeQuarterCurve,
};
